import { render, staticRenderFns } from "./profile-password-remind.vue?vue&type=template&id=3b23eb5e"
import script from "./profile-password-remind.vue?vue&type=script&lang=js"
export * from "./profile-password-remind.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports